var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSup4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 682.309,
    height: 426.174,
    viewBox: "0 0 682.309 426.174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3f3d56;}.b{fill:#44bba4;}.c{fill:#fff;}.d{fill:#f0f0f0;}.e{fill:#f2f2f2;}.f{fill:#2f2e41;}.g{fill:#ffb8b8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-134.544 -2530.823)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 75.98,
    cy: 18.532,
    rx: 75.98,
    ry: 18.532,
    transform: "translate(664.893 2919.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M508.569,162.9V408.142a11.02,11.02,0,0,1-11.019,11.014H397.986a11,11,0,0,1-11.019-11.015V162.9a11.019,11.019,0,0,1,11.02-11.02h14.9v1.912a9.073,9.073,0,0,0,9.073,9.073H472.6a9.073,9.073,0,0,0,9.073-9.073V151.88h15.88A11.016,11.016,0,0,1,508.569,162.9Z",
    transform: "translate(-51.982 2436.678)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 112.87,
    height: 54.975,
    transform: "translate(339.358 2629.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M467.061,265.811c2.955,10.922,13.075,17.686,13.075,17.686s5.33-10.944,2.375-21.866-13.075-17.686-13.075-17.686S464.106,254.889,467.061,265.811Z",
    transform: "translate(-82.259 2401.482)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M462.1,270.248c8.108,7.892,9.1,20.025,9.1,20.025s-12.155-.664-20.262-8.556-9.1-20.025-9.1-20.025S453.995,262.355,462.1,270.248Z",
    transform: "translate(-72.958 2394.699)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M501.013,265.811c-2.955,10.922-13.075,17.686-13.075,17.686s-5.33-10.944-2.375-21.866,13.075-17.686,13.075-17.686S503.967,254.889,501.013,265.811Z",
    transform: "translate(-89.332 2401.482)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M498.467,270.248c-8.108,7.892-9.1,20.025-9.1,20.025s12.155-.664,20.262-8.556,9.1-20.025,9.1-20.025S506.575,262.355,498.467,270.248Z",
    transform: "translate(-91.128 2394.699)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 92.679,
    height: 5.087,
    transform: "translate(349.453 2715.307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 92.679,
    height: 5.087,
    transform: "translate(349.453 2723.502)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 92.679,
    height: 5.087,
    transform: "translate(349.453 2731.699)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 92.679,
    height: 5.087,
    transform: "translate(349.453 2739.896)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 25.298,
    height: 25.298,
    transform: "matrix(0.815, 0.579, -0.579, 0.815, 392.793, 2769.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M486.323,502.625a5.838,5.838,0,1,1,5.838-5.838A5.838,5.838,0,0,1,486.323,502.625Zm0-10.7a4.865,4.865,0,1,0,4.865,4.865,4.865,4.865,0,0,0-4.865-4.865Z",
    transform: "translate(-87.732 2307.061)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M184.087,77.841V323.084A11.02,11.02,0,0,1,173.068,334.1H73.5a11,11,0,0,1-11.019-11.014V77.841A11.019,11.019,0,0,1,73.5,66.822h14.9v1.912a9.073,9.073,0,0,0,9.073,9.073h50.636a9.073,9.073,0,0,0,9.074-9.073V66.822h15.88a11.016,11.016,0,0,1,11.019,11.019Z",
    transform: "translate(72.059 2469.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M178.68,229.712h-97.3V142.627h97.3Zm-96.328-.973h95.355V143.6H82.352Z",
    transform: "translate(64.836 2440.215)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.973,
    height: 129.207,
    transform: "translate(146.377 2583.689) rotate(-48.206)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 129.207,
    height: 0.973,
    transform: "translate(146.376 2669.076) rotate(-41.794)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 96.328,
    height: 0.973,
    transform: "translate(146.702 2695.225)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 96.328,
    height: 0.973,
    transform: "translate(146.702 2703.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 96.328,
    height: 0.973,
    transform: "translate(146.702 2712.738)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 48.164,
    height: 0.973,
    transform: "translate(146.702 2721.494)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 48.164,
    height: 0.973,
    transform: "translate(146.702 2730.252)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M832.263,77.841V323.084A11.02,11.02,0,0,1,821.243,334.1H721.68a11,11,0,0,1-11.019-11.014V77.841a11.019,11.019,0,0,1,11.02-11.019h14.9v1.912a9.073,9.073,0,0,0,9.073,9.073H796.29a9.073,9.073,0,0,0,9.073-9.073V66.822h15.88a11.016,11.016,0,0,1,11.019,11.019Z",
    transform: "translate(-175.722 2469.193)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 96.328,
    height: 0.973,
    transform: "translate(548.07 2661.654)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 96.328,
    height: 0.973,
    transform: "translate(548.07 2686.953)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 96.328,
    height: 0.973,
    transform: "translate(548.07 2712.252)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 15.815,
    cy: 15.815,
    r: 15.815,
    transform: "translate(577.849 2593.088)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 6.811,
    height: 15.568,
    transform: "translate(620.072 2657.275)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 6.811,
    height: 15.568,
    transform: "translate(560.232 2682.088)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 6.811,
    height: 15.568,
    transform: "translate(600.126 2706.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M797.045,189.422a19.46,19.46,0,1,1,19.46-19.46A19.46,19.46,0,0,1,797.045,189.422Zm0-37.948a18.487,18.487,0,1,0,18.487,18.487,18.487,18.487,0,0,0-18.487-18.487Z",
    transform: "translate(-201.305 2437.203)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.235,
    height: 61.313,
    transform: "translate(268.338 2665.453) rotate(-39.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M343.765,354.219a37.337,37.337,0,0,0-11.254-4.4l5.884-2.1,3.177-5.379A37.294,37.294,0,0,0,343.765,354.219Z",
    transform: "translate(-31.165 2363.871)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 61.314,
    height: 1.236,
    transform: "translate(482.289 2711.953) rotate(-50.466)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M618.506,354.219a37.337,37.337,0,0,0,2.193-11.884l3.178,5.38,5.883,2.1A37.3,37.3,0,0,0,618.506,354.219Z",
    transform: "translate(-140.493 2363.871)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1036.205,441.238s0,90.188-14.208,122.927l-32.74,73.509s-21-1.235-22.238-9.884l24.709-76.6,14.825-45.094,3.706-70.421Z",
    transform: "translate(-255.486 2275.771)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1011.587,447.149l-5.56,37.681,3.706,82.775,1.853,45.712s7.413,20.385,4.942,22.238l-4.942,3.706s-19.767-2.471-20.385-3.706-12.355-94.512-12.355-94.512-24.091-75.363-22.856-76.6,6.8-19.767,6.8-19.767Z",
    transform: "translate(-251.253 2272.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1042.238,749.678l2.471,14.208s6.8,29.033,0,29.033-19.15-8.03-19.767-12.972,1.235-27.18,1.235-27.18Z",
    transform: "translate(-277.58 2155.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M984.435,753.769s4.942,9.884,8.03,11.119,17.154,9.317,8.886,14.542-16.916.283-16.916.283L956.02,764.271s3.706-15.443,9.266-16.679S984.435,753.769,984.435,753.769Z",
    transform: "translate(-251.281 2156.588)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 22.238,
    cy: 22.238,
    r: 22.238,
    transform: "translate(704.736 2536.016)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1008.854,190.678s4.324,28.415,8.648,32.122-9.266,16.679-15.443,16.061-12.972-14.208-12.972-14.208,1.853-17.914-1.235-22.856S1008.854,190.678,1008.854,190.678Z",
    transform: "translate(-263.345 2369.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M995.287,243.685,1005.776,234a39.713,39.713,0,0,0,12.364,10.3c8.03,4.324-15.443,48.8-15.443,48.8l-37.681-46.947s11.985-7.967,15.876-11.087Z",
    transform: "translate(-254.72 2352.869)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M992,287.031s16.555-28.86,14.764-38.212c0,0,24.153,6.091,25.388,14.121S1020.412,300,1020.412,300s10.5,73.509,4.324,74.127-67.95,1.235-69.185-1.853,1.235-12.354-2.471-15.443-8.03-1.235-6.177-6.177,9.884-11.119,7.413-14.825-3.089-2.471-2.471-4.942-1.235-35.21-1.235-35.21-12.972-35.828-9.884-38.3,19.29-8.561,19.29-8.561Z",
    transform: "translate(-245.253 2347.203)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1093.756,464s-1.853,24.709-12.354,23.474,1.853-27.8,1.853-27.8Z",
    transform: "translate(-297.594 2266.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M955.015,461.473s3.706,14.825,8.03,13.59v-17.3l-1.853-3.089Z",
    transform: "translate(-250.897 2268.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M992,173.9a3.842,3.842,0,0,0-.634-1.788,2.9,2.9,0,0,0-1.352-.857,6.074,6.074,0,0,0-7.238,3.1c-.57,1.244-.844,2.846-2.1,3.4-1.454.644-3.067-.727-3.639-2.211s-.587-3.167-1.348-4.563a6.659,6.659,0,0,0-4.574-3.022c-1.529-.324-3.4-.494-4.09-1.9a3.754,3.754,0,0,1-.279-1.7,17.893,17.893,0,0,1,1.1-6.048c-6.052-1.209-11.435,4.7-17.606,4.793a4.648,4.648,0,0,1-2.27-.445c-1.369-.731-1.964-2.353-2.377-3.849q-.657-2.384-1.082-4.825l1.974.906a7.753,7.753,0,0,1-.881-3.405,8.148,8.148,0,0,1,3.038.256l.144-3.542c1.527,1.936,4.571,1.256,6.868.359,4.433-1.73,8.844-3.6,13.5-4.6s9.64-1.072,14.04.742c4.624,1.906,8.189,5.7,11.329,9.588a25.055,25.055,0,0,1,4.363,7.033,17.046,17.046,0,0,1-.037,10.872c-1.013,3.171-2.9,7.008-5.431,9.205C992.535,179.167,992.418,176.3,992,173.9Z",
    transform: "translate(-246.884 2387.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M941.547,259.678l-8.031,1.853s-9.266,9.884-9.884,19.15-.618,55.6-.618,55.6l11.737,38.3s-1.235,8.648,0,8.648,1.853-1.853,1.853.618-3.089,0,0,2.471l6.177,4.942,10.324-13.688s.8-5.462-1.058-6.7-1.853-1.853-1.235-3.706,1.853-2.471,1.235-3.706-2.471-3.089-2.471-4.324,0-2.471-.618-3.089-4.942-15.443-4.942-15.443l2.471-48.183Z",
    transform: "translate(-238.664 2343.053)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1072.521,264.678l6.177,3.089s9.884,29.651,9.884,55.6,1.853,43.241,1.853,43.241,3.089,7.413,1.853,7.413-2.471,0-1.235,1.853,1.853,1.235,1.235,3.089-1.235-1.235-.618,1.853,0,4.324-1.235,4.324-1.235,8.03-1.235,8.03l-14.825-5.56s2.471-3.089,1.853-4.324a6.156,6.156,0,0,1-.618-2.471s3.089-.618,0-1.853-1.853-1.235-1.235-4.942,2.471-3.089.618-3.706-12.972-58.066-12.972-58.066Z",
    transform: "translate(-291.802 2341.141)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 1.853,
    cy: 1.853,
    r: 1.853,
    transform: "translate(738.702 2594.898)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 1.853,
    cy: 1.853,
    r: 1.853,
    transform: "translate(738.702 2601.076)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSup4);
export default __webpack_public_path__ + "static/media/sup4.689b3925b810d8f94f7f3b169c980fbd.svg";
export { ForwardRef as ReactComponent };